import Path from '../Path';

function createNext(next, path) {
  return function (payload) {
    return new Path(path, payload);
  };
}

export default function PathProvider() {
  return function (context, functionDetails, payload, next) {
    if (functionDetails.outputs) {
      context.path = Object.keys(functionDetails.outputs).reduce(function (output, outputPath) {
        output[outputPath] = createNext(next, outputPath);

        return output;
      }, {});
    }

    return context;
  };
}
//# sourceMappingURL=Path.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/function-tree/es/providers/Path.js
// module id = 525
// module chunks = 1